import React from 'react';

const SportPassFormFilterNoFull = ({ sportsPassFilterFilterActiveNotFull, OnChangeFilterNotFull }) => (
	<div 
		className="generic-filters-select sports-pass-filters-select sports-pass-filters-no-full"
		data-testid="sports-pass-filter-no-full"
	>
		<label className="switch">
			<span className="switch-text">Places restantes uniquement</span>
			<input 
				type="checkbox" 
				value="not-full" 
				onChange={OnChangeFilterNotFull} 
				checked={sportsPassFilterFilterActiveNotFull ? 'checked' : false} 
			/>
			<span className="slider round"></span>
		</label>
	</div>
)

export default SportPassFormFilterNoFull;
